/**
 * SA demo-tenant delete mutation hook (B-11).
 *
 * Endpoint: DELETE /admin/demo/{slug}
 */
import { useMutation } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import { ApiError } from "@/lib/apiError";
import { queryClient } from "@/lib/queryClient";

interface DemoDeleteBody {
  /** Must equal `"DELETE DEMO {slug}"` */
  confirm: string;
}

interface DemoDeleteResponse {
  deleted_tenant_id: string;
  slug: string;
  audit_event_id: string;
}

export function useDeleteDemo(slug: string) {
  return useMutation<DemoDeleteResponse, ApiError, DemoDeleteBody>({
    mutationFn: async (body) => {
      const r = await apiClient.delete<DemoDeleteResponse>(
        `/admin/demo/${slug}`,
        { data: body },
      );
      return r.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["admin", "demos"] });
      queryClient.invalidateQueries({ queryKey: ["admin", "tenants"] });
    },
  });
}
